<template>
  <li
    v-if="state && query"
    class="margin-right-sm"
  >
    <button
      class="icon-facet-pill tag flat rounded"
      style="
        --tag-background: var(--white);
        --button-margin-bottom: 0;
        --button-hover-background: var(--white);
        --button-active-background: var(--white);
        --link-decoration-style: none;
        --link-decoration-line: none;
        --link-hover-decoration-style: none;
        --link-hover-decoration-line: none;
        --tag-padding: var(--spacing-sm) var(--spacing-md);
      "
      @click.prevent="clearSearchQuery()"
    >
      &ldquo;{{ query }}&rdquo;
      <font-awesome-icon
        :icon="$v6.solid.faXmark"
        fixed-width
        class="icon-facet-pill-affordance margin-left-4xs"
      />
    </button>
  </li>
</template>

<script>
  import { createWidgetMixin } from 'vue-instantsearch'
  import { connectStats } from 'instantsearch.js/es/connectors'

  export default {
    name: 'SearchRefinementWidget',

    mixins: [createWidgetMixin({ connector: connectStats })],

    computed: {
      query() {
        return this.state.query
      }
    },

    methods: {
      clearSearchQuery() {
        this.$emit('clearSearchQuery')
      }
    }
  }
</script>
